// extracted by mini-css-extract-plugin
export default {"reviews-summary":"_f2updc","reviewsSummary":"_f2updc"};